/**
 * Provider-agnostic vocabulary of the payment-risk domain.
 *
 * This file is the SINGLE source of truth for every risk union. The DB CHECK
 * constraints, the admin DTOs and the RU label maps in `ui-domain` all mirror
 * these values, and each mirror is a `Record<Union, …>` so that adding a value
 * here without teaching the mirrors about it fails the build rather than
 * leaking a machine key in front of an operator.
 */
/** Confidence levels from weakest to strongest — the one ordering allowed. */
export const RISK_MATCH_CONFIDENCE_ORDER = [
    'none',
    'low',
    'medium',
    'high',
    'confirmed',
];
//# sourceMappingURL=types.js.map